define('customersTabs',[
	'underscore',
  'rolesMixin'
], function (_,
             RolesMixin) {
  'use strict';

  var customersTabs = [
      {
        route: 'profile',
        name: 'profile',
        role : RolesMixin.DASHBOARD_CUSTOMERS_CUSTOMERS_PROFILE,
        title: _.i18n('endUsersDetail.profile.tabTitle')
      }, {
        route: 'logosimages',
        name: 'logosimages',
        role : RolesMixin.DASHBOARD_CUSTOMERS_CUSTOMERS_LOGOSIMAGES,
        title: _.i18n('endUsersDetail.logosImages.tabTitle')
      }, {
        route: 'datasets',
        name: 'datasets',
        role : RolesMixin.DASHBOARD_CUSTOMERS_CUSTOMERS_DATASETS,
        title: _.i18n('endUsersDetail.dataset.tabTitle')
      }, {
        route: 'producttemplates',
        name: 'producttemplates',
        role : RolesMixin.DASHBOARD_CUSTOMERS_CUSTOMERS_PRODUCTTEMPLATES,
        title: _.i18n('endUsersDetail.corporateTemplates.tabTitle')
      }, {
        route: 'templates',
        name: 'templates',
        role : RolesMixin.DASHBOARD_CUSTOMERS_CUSTOMERS_TEMPLATES,
        title: _.i18n('endUsersDetail.templates.tabTitle')
      }, {
        route: 'designelements',
        name: 'designelements',
        role : RolesMixin.DASHBOARD_CUSTOMERS_CUSTOMERS_DESIGNELEMENTS,
        title: _.i18n('endUsersDetail.design-elements.tabTitle')
      }, {
        route: 'orders',
        name: 'orders',
        role : RolesMixin.DASHBOARD_CUSTOMERS_CUSTOMERS_ORDERS,
        title: _.i18n('endUsersDetail.orders.tabTitle')
      }, {
        route: 'attachments',
        name: 'attachments',
        role : RolesMixin.DASHBOARD_CUSTOMERS_CUSTOMERS_ATTACHMENTS,
        title: 'Attachments'
      }, {
        route: 'fonts',
        name: 'fonts',
        role : RolesMixin.DASHBOARD_CUSTOMERS_CUSTOMERS_FONTS,
        title: _.i18n('font.custom')
      }, {
        route: 'contacts',
        name: 'contacts',
        role : RolesMixin.DASHBOARD_CUSTOMERS_CUSTOMERS_CONTACTS,
        title: _.i18n('endUsersDetail.contacts.tabTitle')
      }
    ];

  return customersTabs;
});
